import React from "react";
import "./index.css";
import logo from "../assets/logo.svg";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="header flex flexCenter flexCol">
      <div className="logo container-sm flex justifyBetween alignCenter">
        <Link to={"/"}>
          <img src={logo} alt="Logo" />
        </Link>
        <a className="btn btnViolet" href="tel:8188188408" target="_blank">
          Call us
        </a>
      </div>
    </div>
  );
};

export default Header;
